import { render } from "./simpeg-pegawai-import.vue?vue&type=template&id=3e130dc5"
import script from "./simpeg-pegawai-import.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-import.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__